import { today } from '../care/CareRecord';

/**
 * Days worth dressing up for. Fixed-date holidays, US Thanksgiving, and the
 * anniversary of the day she came to you ("together since").
 */
export interface Holiday {
  id: string;
  name: string; // HUD line
  hat: 'party' | 'santa' | 'witch' | null;
  confetti: boolean;
  lights: boolean;
  emoji: string;
}

function thanksgiving(y: number): string {
  // 4th Thursday of November
  const nov1 = new Date(y, 10, 1);
  const firstThu = 1 + ((4 - nov1.getDay() + 7) % 7);
  return `${y}-11-${String(firstThu + 21).padStart(2, '0')}`;
}

export function holidayFor(date: Date, togetherSince: string | null): Holiday | null {
  const d = today(date);
  const md = d.slice(5);
  const y = date.getFullYear();
  if (togetherSince && togetherSince.slice(5) === md && togetherSince < d) {
    const years = y - Number(togetherSince.slice(0, 4));
    return { id: 'anniversary', name: `${years} year${years === 1 ? '' : 's'} together today!`, hat: 'party', confetti: true, lights: true, emoji: '🎉' };
  }
  const fixed: Record<string, Holiday> = {
    '01-01': { id: 'newyear', name: 'Happy New Year!', hat: 'party', confetti: true, lights: false, emoji: '🎆' },
    '02-14': { id: 'valentine', name: "Happy Valentine's Day", hat: null, confetti: true, lights: false, emoji: '💜' },
    '07-04': { id: 'july4', name: 'Happy Fourth!', hat: null, confetti: true, lights: false, emoji: '🎇' },
    '10-31': { id: 'halloween', name: 'Happy Halloween!', hat: 'witch', confetti: false, lights: false, emoji: '🎃' },
    '12-24': { id: 'xmas-eve', name: "Christmas Eve", hat: 'santa', confetti: false, lights: true, emoji: '🎄' },
    '12-25': { id: 'xmas', name: 'Merry Christmas!', hat: 'santa', confetti: false, lights: true, emoji: '🎄' },
    '12-31': { id: 'nye', name: "New Year's Eve", hat: 'party', confetti: true, lights: true, emoji: '🥂' },
  };
  if (fixed[md]) return fixed[md];
  if (d === thanksgiving(y)) return { id: 'thanksgiving', name: 'Happy Thanksgiving — extra treats today', hat: null, confetti: false, lights: false, emoji: '🦃' };
  return null;
}

/** whole days from `since` (YYYY-MM-DD) to today, inclusive of the first day */
export function daysTogether(since: string | null, date = new Date()): number {
  if (!since) return 0;
  const [y, m, d] = since.split('-').map(Number);
  const start = new Date(y, m - 1, d).getTime();
  const now = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
  return Math.max(1, Math.round((now - start) / 86400000) + 1);
}
